
export default {
  // 标题行左右布局
  name: 'TitleRow',
  props: {
    refresh: Boolean,
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '查看更多',
    },
    // 触发时间
    delayTime: {
      type: Number,
      default: 300,
    },
    hideRight: Boolean,
  },
  data() {
    return {
      rounding: null,
    }
  },
  methods: {
    click() {
      // 立刻执行
      if (this.delayTime === 0) return this.$emit('click')
      // 延缓执行
      if (this.rounding) return
      this.rounding = 'round'
      setTimeout(() => {
        this.rounding = null
        this.$emit('click')
      }, this.delayTime)
    },
  },
}
